import { api} from '../../api/reportsAPI.js'
import { serverApi} from '../../api/serverAPI.js'
//api.interceptors.request.baseUrl="http://localhost:1337";
const datas = {
    printCertificates: (args) => new Promise((resolve, reject) => {
      
        api.post('/certificate',args,{responseType:'arraybuffer'})
          .then(function (response) {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }),
      printLabels: (args) => new Promise((resolve, reject) => {
      
        api.post('/labels',args)
          .then(function (response) {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }),
      printLor:(args) => new Promise((resolve, reject) => {
        api.post('/lor',args)          
        .then(function (response) {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    }),
      printLors:(args) => new Promise((resolve, reject) => {
        // !!important you must add the responseType to be arraybuffer to get the pdf back
      api.post('/lors',args,{responseType:'arraybuffer'})          
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  saveCertUrl:(args) => new Promise((resolve, reject) => {
    // !!important you must add the responseType to be arraybuffer to get the pdf back
  serverApi.post('/certificates/saveCertUrl',args)          
  .then(function (response) {
    resolve(response)
  })
  .catch((error) => {
    reject(error)
  })
}),
}
export default datas


// WEBPACK FOOTER //
// ./src/components/Certificates/api.js